<div class="info-icon-message" *ngIf="infoisVisible">
  <cwc-tooltip content="{{ text | translate }}" designVersion="v2">
    <cwc-icon name="information-rounded-fill" color="disabled-grey" size="1.5rem" designVersion="v2"></cwc-icon>
  </cwc-tooltip>
</div>
